import { SxProps, Theme } from '@mui/system';

const styles = {
  container: {
    backgroundColor: 'secondary.main',
    padding: '18px',
    display: 'flex',
    justifyContent: 'space-between',
    marginTop: '16px',
    borderRadius: '10px',
  },
  price: {
    mt: '2px',
    mb: '10px',
    display: 'flex',
    position: 'relative',
    width: 'fit-content',
    alignItems: 'center',
  },
  priceLabel: {
    fontWeight: '600',
    fontSize: 16,
    color: 'primary.main',
    textAlign: 'right',
  },
  updateButton: {
    fontSize: 14,
    fontWeight: '500',
    padding: 0,
    textDecoration: 'underline',
  },
} satisfies Record<string, SxProps<Theme>>;

export default styles;
